export default [
  { path: '/main/log', name: 'MainLog', component: () => import(/* webpackChunkName: "main-log" */ './index.vue') }
]